
export default function QuestionsSection() {
  const questions = [
    "What credentials do you hold (CPA, EA, AFSP)?",
    "How many years have you been preparing business tax returns?",
    "Do you have experience with businesses in my specific industry?",
    "What is your fee structure, and what does it include?",
    "Are you available year-round for questions and tax planning?",
    "How do you handle IRS notices or audit situations?",
    "What technology do you use for document collection and communication?",
    "Will I work with the same preparer every year?",
    "Do you carry professional liability (errors and omissions) insurance?",
    "Can you provide references from El Paso business clients?",
    "How do you stay current with changes in tax law?",
    "What is your process for reviewing my return before filing?"
  ];

  return (
    <section className="mb-16">
      <h2 className="text-3xl font-bold text-gray-900 mb-8">7. Essential Questions to Ask Before Hiring a Tax Preparer in El Paso TX</h2>

      <div className="grid md:grid-cols-2 gap-8 items-start mb-10">
        <div>
          <p className="text-gray-600 leading-relaxed mb-4">
            Armed with the knowledge from the previous sections, you are now ready to interview prospective tax preparers with confidence. The questions you ask during an initial consultation will reveal everything you need to know about whether a particular service is the right fit for your El Paso business. Do not be shy about asking tough questions—any reputable preparer will welcome them because they demonstrate that you are a serious, engaged client.
          </p>
          <p className="text-gray-600 leading-relaxed mb-4">
            When you <strong>compare tax preparation services</strong>, treat the initial consultation like a job interview. You are hiring someone to handle one of the most sensitive and consequential aspects of your business. The right preparer will answer every question thoroughly, provide documentation to support their claims, and make you feel confident in their ability to serve your needs. If a preparer seems evasive, dismissive, or impatient with your questions, that tells you everything you need to know about the service you would receive as a client.
          </p>
          <p className="text-gray-600 leading-relaxed">
            Remember that the best tax preparation relationships in <strong>El Paso TX</strong> are built on mutual trust and open communication. A great preparer wants to understand your business goals, not just your tax documents. They should ask you questions too—about your growth plans, your biggest financial challenges, and your long-term objectives. If the conversation feels one-sided, keep looking.
          </p>
        </div>
        <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
            <i className="ri-questionnaire-line text-teal-600 text-xl"></i>
            Your Interview Checklist
          </h3>
          <div className="space-y-3">
            {questions.map((question, index) => (
              <div key={index} className="flex items-start gap-3 bg-white rounded-lg p-3 shadow-sm">
                <div className="w-6 h-6 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-white text-xs font-bold">{index + 1}</span>
                </div>
                <span className="text-gray-700 text-sm leading-relaxed">{question}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="w-full h-72 rounded-2xl overflow-hidden shadow-lg">
        <img
          src="https://public.readdy.ai/ai/img_res/88d934914fa1ef8f5363dc6dd3ed4a48.jpg"
          alt="tax-preparer-consultation-questions-el-paso-tx"
          title="Questions to Ask Tax Preparers in El Paso TX"
          className="w-full h-full object-cover object-top"
        />
      </div>
    </section>
  );
}
